<template>
  <el-dialog v-model="dialogFormVisible" :title="title" @close="closeDialog">
    <el-form
      :model="addSysUserForm"
      ref="addSysUserRef"
      :rules="addSysUserrules"
    >
      <el-form-item
        label="科室"
        :label-width="formLabelWidth"
        prop="userName"
      >
        <el-input
          v-model="addSysUserForm.userName"
          autocomplete="off"
          ref="name"
          placeholder="请填写科室"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="报修账号"
        :label-width="formLabelWidth"
        prop="mobile"
        v-if="addSysUserForm.userType !== 1"
      >
        <el-input
          v-model="addSysUserForm.mobile"
          autocomplete="off"
          ref="mobile"
          placeholder="请填写报修账号"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="用户类型"
        :label-width="formLabelWidth"
        prop="userType"
      >
        <el-select v-model="addSysUserForm.userType" placeholder="请选择类型" @change="onUserTypeChange">
          <el-option label="系统管理员" :value="1"></el-option>
          <el-option label="报修员" :value="2"></el-option>
          <el-option
            v-for="item in repairTypeList"
            :key="item.userType"
            :label="item.typeName + '维修员'"
            :value="item.userType"
          ></el-option>
          <el-option label="小程序管理员" :value="99"></el-option>
          <el-option label="新增类型维修员" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="addSysUserForm.userType === 0"
        label="维修类型"
        :label-width="formLabelWidth"
        prop="newTypeName"
      >
        <div style="display: flex; align-items: center;">
          <el-input
            v-model="newTypeName"
            placeholder="请输入维修类型"
            style="flex: 1"
          ></el-input>
          <span style="margin-left: 8px; color: #606266; font-size: 14px">维修员</span>
        </div>
      </el-form-item>
      <el-form-item
        label="是否可用"
        :label-width="formLabelWidth"
        prop="isDelete"
        v-if="addSysUserForm.id"
      >
        <el-select
          v-model="addSysUserForm.isDelete"
          placeholder="请选择是否可用"
        >
          <el-option label="可用" :value="0"></el-option>
          <el-option label="禁用" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="系统密码"
        :label-width="formLabelWidth"
        prop="userPassword"
        v-if="addSysUserForm.userType === 1"
      >
        <el-input
          v-model="addSysUserForm.userPassword"
          autocomplete="off"
          ref="name"
          type="password"
          placeholder="请填写系统密码"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="确认密码"
        :label-width="formLabelWidth"
        prop="rePassword"
        v-if="addSysUserForm.userType === 1"
      >
        <el-input
          v-model="addSysUserForm.rePassword"
          autocomplete="off"
          type="password"
          placeholder="请在此填写密码"
        ></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="cancel()">取消</el-button>
        <el-button type="primary" @click="save()">保存</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { ref } from "vue";
import { httpService } from "@/utils/httpService";
import { ElMessage, ElForm } from "element-plus";
import { vxRule } from "@/utils/validator";

export default {
  name: "AddSysUser",
  components: { ElForm, ElMessage },
  data() {
    return {
      dialogFormVisible: ref(false),
      formLabelWidth: "120px",
      title: "",
      personnelType: "",
      addSysUserForm: {
        userName: "",
        userType: "",
        userPassword: "",
        isDelete: "",
        campus: "",
        rePassword: "",
        mobile: "",
      },
      newTypeName: "",
      repairTypeList: [],
    };
  },
  computed: {
    // 校验规则：系统管理员(userType=1)报修账号不必填、系统密码必填；其他类型反之
    // 编辑时系统密码可留空以保留原密码（后端动态更新，空值不覆盖）
    addSysUserrules() {
      const isSysAdmin = this.addSysUserForm.userType === 1;
      const isAdd = !this.addSysUserForm.id;
      return {
        userName: vxRule(true, null, "blur"),
        userType: vxRule(true, null, "blur"),
        isDelete: vxRule(true, null, "blur"),
        mobile: vxRule(!isSysAdmin, null, "blur"),
        userPassword: vxRule(isSysAdmin && isAdd, null, "blur"),
      };
    },
  },
  watch: {
    dialogFormVisible: {
      handler(val) {
        if (val) {
          this.loadRepairTypeList();
        }
      },
      immediate: false,
    },
  },
  methods: {
    loadRepairTypeList() {
      httpService("/api/sysUser/repairTypeList", {}, "get").then((data) => {
        if (data.code == 200 && data.obj) {
          this.repairTypeList = data.obj;
        }
      });
    },
    onUserTypeChange(val) {
      if (val !== 0) {
        this.newTypeName = "";
      }
      // 切换类型时清空隐藏字段的值，避免提交脏数据
      if (val === 1) {
        this.addSysUserForm.mobile = "";
      } else {
        this.addSysUserForm.userPassword = "";
        this.addSysUserForm.rePassword = "";
      }
      // 切换类型后清除遗留的校验提示
      this.$nextTick(() => {
        this.$refs.addSysUserRef && this.$refs.addSysUserRef.clearValidate();
      });
    },
    closeDialog() {
      this.clear();
    },
    cancel() {
      this.dialogFormVisible = false;
      this.clear();
    },
    getSysUserById(id) {
      httpService("/api/sysUser/queryById", { id: id }, "get").then((data) => {
        data.userPassword = "";
        data.rePassword = "";
        // 后端返回的 userType 可能为字符串，转为数字以保证 v-if 严格比较(===/!==)生效
        if (data.userType != null) data.userType = Number(data.userType);
        this.addSysUserForm = data;
        // 编辑加载后按当前类型清空隐藏字段，与新增切换类型逻辑保持一致
        if (data.userType === 1) {
          this.addSysUserForm.mobile = "";
        } else {
          this.addSysUserForm.userPassword = "";
          this.addSysUserForm.rePassword = "";
        }
      });
    },
    clear() {
      this.dialogFormVisible = false;
      //清空form
      this.addSysUserForm.id = "";
      this.addSysUserForm.userName = "";
      this.addSysUserForm.userType = "";
      this.addSysUserForm.userPassword = "";
      this.addSysUserForm.rePassword = "";
      this.addSysUserForm.isDelete = "";
      this.addSysUserForm.campus = "";
      this.addSysUserForm.mobile = "";
      this.newTypeName = "";
    },
    save() {
      this.$refs.addSysUserRef.validate((valid) => {
        if (valid) {
          let params = new FormData(); //创建一个form对象,必须是form对象否则后端接受不到数据
          params.append("userName", this.addSysUserForm.userName);
          params.append("userType", this.addSysUserForm.userType);
          params.append("userPassword", this.addSysUserForm.userPassword);
          params.append("isDelete", this.addSysUserForm.isDelete);
          params.append("mobile", this.addSysUserForm.mobile);

          if (
            this.addSysUserForm.userPassword != this.addSysUserForm.rePassword
          ) {
            ElMessage.error("两次密码输入不一致");
            return;
          }
          if (this.addSysUserForm.id) {
            params.append("id", this.addSysUserForm.id);
            httpService("/api/sysUser/edit", params, "post").then((data) => {
              if (data.code == 200) {
                ElMessage.success("修改成功");
                this.clear();
                //刷新父组件的数据
                this.$parent.getSysUserList();
                this.$parent.loadRepairTypeList();
              } else {
                ElMessage.error("修改失败");
              }
            });
          } else {
            if (this.addSysUserForm.userType === 0 && (!this.newTypeName || !this.newTypeName.trim())) {
              ElMessage.error("请输入维修类型名称");
              return;
            }
            if (this.addSysUserForm.userType === 0) {
              params.append("newTypeName", this.newTypeName.trim());
              params.delete("userType");
              params.append("userType", "");
            }
            httpService("/api/sysUser/add", params, "post").then((data) => {
              if (data.code == 200) {
                ElMessage.success("添加成功");
                this.clear();
                //刷新父组件的数据
                this.$parent.getSysUserList();
                this.$parent.loadRepairTypeList();
              } else {
                ElMessage.error(data.msg);
              }
            });
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style>
.el-select {
  width: 100%;
}
</style>